import {TabState, TabStateDefaults} from 'Navigation';

export default class EntityMapTabState extends TabState {
  defaults(): TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Entity Map',
      closeable: false,
      preferenceKey: 'entity-map',
    };
  }
}
